mp.googlemap = {
    initDone: false,
    apiKey: 'AIzaSyBVbpdpU75XwGaWAxqDGwi_Qq4Xr28xLI8',

    init: function () {
        if ($('.mpGoogleMap').length > 0) {
            mp.googlemap.loadScript();
        }
        $('.mpLoadMap').on('click', mp.googlemap.loadModalMap);
    },

    loadScript: function () {
        if(!mp.googlemap.initDone) {
            mp.googlemap.initDone = true;
            var script = document.createElement('script');
            script.setAttribute('src', 'https://maps.google.com/maps/api/js?key=' + mp.googlemap.apiKey + '&callback=mp.googlemap.loadDirectMaps');
            document.body.appendChild(script);
        } else {
            mp.googlemap.loadDirectMaps(); // FIXME: Fehler abfangen, wenn noch nicht ganz fertig geladen
        }
    },

    loadModalMap: function(ev) {
        ev.preventDefault();

        var ref = $(this);
        var data = {
            marker: ref.data('marker')
        };

        $('#mpGenericModal .modal-dialog,#mpGenericModal .modal-content,#mpGenericModal .modal-body').addClass('h-100');
        $('#mpGenericModal .modal-title').html(ref.attr('title'));
        $('#mpGenericModal .modal-body').html(Mustache.render(mp.templates.googleOverlay, data));
        $('#mpGenericModal').modal('show');
        mp.googlemap.loadScript();

        return false;
    },

    loadDirectMaps: function () {
        $('.mpGoogleMap:not(.mpMapsDone)').each(function () {
            var ref = $(this);
            ref.addClass('mpMapsDone');

            var mapOptions = {
                zoom: 11,
                scrollwheel: false,
                center: new google.maps.LatLng(0, 0)
            };

            var latlng = null;
            if (typeof ref.data('marker') !== 'undefined') {
                latlng = ref.data('marker').split(',');
                mapOptions.center = new google.maps.LatLng(latlng[0], latlng[1]);
            }

            var map = new google.maps.Map(ref[0], mapOptions);
            if (latlng != null) {
                new google.maps.Marker({
                    position: new google.maps.LatLng(latlng[0], latlng[1]),
                    map: map
                });
            }
        });
    }
};

$(document).ready(function () {
    mp.googlemap.init();
});